import { render, staticRenderFns } from "./get-label-name.vue?vue&type=template&id=797645ab&scoped=true"
import script from "./get-label-name.vue?vue&type=script&lang=ts"
export * from "./get-label-name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797645ab",
  null
  
)

export default component.exports